import { useLanguage } from '@/contexts/LanguageContext';
import { Check, Briefcase } from 'lucide-react';

export function StepLeistungen({ form, setForm, optionen }) {
  const { t } = useLanguage();

  const toggle = (item) => {
    setForm(prev => ({
      ...prev,
      leistungen: prev.leistungen.includes(item)
        ? prev.leistungen.filter(i => i !== item)
        : [...prev.leistungen, item],
    }));
  };

  const leistungsListe = optionen?.leistungen || [];

  return (
    <div className="space-y-5" data-testid="step-leistungen">
      <div className="text-center mb-6">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3">
          <Briefcase className="h-6 w-6 text-primary" />
        </div>
        <h3 className="font-serif text-xl font-bold text-foreground">{t('dlWizard.step2Title')}</h3>
        <p className="text-sm text-muted-foreground mt-1">{t('dlWizard.step2Desc')}</p>
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-2 block">
          {t('dlWizard.leistungenLabel')} * <span className="font-normal text-muted-foreground">({form.leistungen.length} {t('dlWizard.gewaehlt')})</span>
        </label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="leistungen-auswahl">
          {leistungsListe.map((l, i) => {
            const key = typeof l === 'object' ? l.key : l;
            const label = typeof l === 'object' ? l.label : l;
            const selected = form.leistungen.includes(key);
            return (
              <button
                key={i}
                onClick={() => toggle(key)}
                className={`px-3 py-2.5 text-xs rounded-lg border-2 transition-all text-left ${
                  selected
                    ? 'bg-primary/5 border-primary text-foreground font-medium'
                    : 'bg-white border-warm-200 text-foreground hover:border-primary/40'
                }`}
                data-testid={`leistung-${i}`}
              >
                {selected && <Check className="h-3 w-3 mr-1 inline text-primary" />}
                {label}
              </button>
            );
          })}
        </div>
      </div>

      {form.leistungen.length === 0 && (
        <p className="text-xs text-amber-600 bg-amber-50 rounded-lg p-3">
          {t('dlWizard.leistungenHinweis')}
        </p>
      )}
    </div>
  );
}
